import React from 'react';
import { useSelector } from 'react-redux';
import { AgCharts } from 'ag-charts-react';
import 'ag-charts-enterprise';

const AverageNetChart = () => {
    const { hourlySales } = useSelector(state => state.reports || {});

    const renderer = (params) => {
        return (
            `<div class="ag-chart-tooltip-custom"><b class="title">${params.datum.time}:00</b><br/><b>Average Net Transaction: ${params.datum.avgSale}</b><br/><b>Previous Day: ${params.datum.prevSales}</b></div>`
        );
    };

    const chartOptions = {
        data: hourlySales,
        series: [
            {
                type: "bar",
                xKey: "time",
                yKey: "avgSale",
                yName: "Average Net Transaction (Dollars)",
                interpolation: { type: "smooth" },
                tooltip: { renderer },
                fill:   '#4ABA6C',
                barWidth: 10,
            }
        ],
        axes: [
          {
            type: 'time',  // X-axis is a category axis for the date
            position: 'bottom',
            label: {
                formatter: ({ value }) => `${(value % 24).toString()}:00`,
            },
            gridLine: {
                enabled: true,
            },
            interval: {
                step: 1,
                maxSpacing: 13,
            },
          },
          {
            type: 'number',
            position: 'left',
            keys: ["avgSale"],
            label: {
                formatter: ({ value }) => `$${value}`,
            },
            gridLine: {
                enabled: true,
              }
          },
        ],
        background: {
            fill: '#f8f9fa', // Set background color here
        },
    };
    
    return(
        <React.Fragment>
            <h3 className="m-0 text-center text-justify mt-2">Average Net Transaction</h3>
            <div style={{ height: 450 }}>
                <AgCharts options={chartOptions} style={{ height: 450 }}/>
            </div>
        </React.Fragment>
    )
};
export default AverageNetChart;